/**
 * Cmd/Ctrl+K belongs to the global "Search or ask Bill" field. A surface that
 * needs the shortcut for itself marks its container with this attribute (a literal `data-mod-k-scope` in JSX is fine); the
 * global handler then ignores key events from inside it, and the local owner
 * acts only on events from inside its own container. The two scopes are
 * disjoint, so listener registration order never matters.
 */
export const MOD_K_SCOPE_ATTRIBUTE = 'data-mod-k-scope';

export function isModK(e: KeyboardEvent): boolean {
  return (
    (e.metaKey || e.ctrlKey) &&
    !e.altKey &&
    !e.shiftKey &&
    e.key.toLowerCase() === 'k' &&
    !e.isComposing &&
    !e.repeat
  );
}

export function isInsideModKScope(target: EventTarget | null): boolean {
  return target instanceof Element && target.closest(`[${MOD_K_SCOPE_ATTRIBUTE}]`) !== null;
}

/** Shortcut hint for the trigger: the Command glyph on Apple platforms, else "Ctrl K". */
export function modKShortcutLabel(): string {
  return /Mac|iPhone|iPad|iPod/.test(navigator.userAgent) ? '⌘K' : 'Ctrl K';
}
